export enum StatusEnum {
  Active = 10,
  Cancelled = 20,
  Expired = 30,
  Matched = 40,
  DealExpired = 50,
  ShipperExitedDealBeforePayment = 60,
  CarrierExitedDealBeforePayment = 70,
  PaymentPending = 80,
  ShipperExitedDealInPaymentPending = 90,
  CarrierExitedDealInPaymentPending = 100,
  BookingConfirmed = 110,
  ShipperRequestedRevision = 120,
  ShipperRevisedBooking = 130,
  CarrierRevisedBooking = 140,
  DealToBeClosed = 145,
  ShipperExitedDealAfterPayment = 150,
  CarrierExitedDealAfterPayment = 160,
  Closed = 170,
  ShipperExitedDealAfterClosed = 180,
  CarrierExitedDealAfterClosed = 190,
  SupplierPenalisedDeal = 200
}
